let ymapsPromise: Promise<IYmaps>;

export default function loadYmapsApi(modules: string[]): Promise<IYmaps> {
  if (!ymapsPromise) {
    ymapsPromise = new Promise((resolve, reject) => {
      if (window.ymaps) {
        resolve(window.ymaps);
        return;
      }

      const e = window.document.createElement('script');
      e.src = 'https://enterprise.api-maps.yandex.ru/2.1/?apikey=ad7bd5e9-cdc2-47b7-8455-8d4800185ea7&lang=ru-RU&load=Map';
      e.async = true;
      e.defer = true;
      e.onload = () => {
        window.ymaps.ready(() => {
          resolve(window.ymaps);
        });
      };
      e.onerror = () => {
        reject(new Error('Unable to load Yandex Maps API'));
      };
      window.document.body.appendChild(e);
    });
  }

  return ymapsPromise
    .then((ymaps): Promise<IYmaps> => {
      return new Promise((resolve, reject) => {
        ymaps.load(modules, () => {
          resolve(ymaps);
        }, reject);
      });
    });
}
